// import appConfig from "../config/appConfig";

// (function () {
//   let devtoolsOpen = false;
//   let lastState = false;

//   let checking = false;
//   let intervalId = null;
//   let started = false;

//   function checkBySize() {
//     // Old logic - commented out
//     // const widthThreshold = window.outerWidth - window.innerWidth > 100;
//     // const heightThreshold = window.outerHeight - window.innerHeight > threshold;

//     // New logic: Check if difference between outer and inner dimensions exceeds 60px
//     const widthDifference = Math.abs(window.outerWidth - window.innerWidth);
//     console.log(widthDifference);
//     // const heightDifference = Math.abs(window.outerHeight - window.innerHeight);

//     // Devtools detected if difference is more than 60px in either dimension
//     const widthThreshold = widthDifference > 10;
//     // const heightThreshold = heightDifference > 1000;

//     // return widthThreshold || heightThreshold;
//     return widthThreshold;
//   }

//   function checkByTiming() {
//     // "Debugger" time-based trick
//     const start = performance.now();
//     // ⚠️ In production you may want to comment this out to avoid pauses
//     // eslint-disable-next-line no-debugger
//     // debugger;
//     const end = performance.now();
//     return end - start > 100; // ms – tweak as needed
//   }

//   function checkDevtools() {
//     if (!appConfig.isProduction) return;
//     if (checking) return;
//     checking = true;

//     let suspicious = checkBySize();
//     console.log(suspicious, "suspicious");

//     if (!suspicious) {
//       suspicious = checkByTiming();
//     }

//     devtoolsOpen = suspicious;

//     if (devtoolsOpen !== lastState) {
//       console.log('i wanna send event')
//       lastState = devtoolsOpen;
//       window.dispatchEvent(
//         new CustomEvent("devtools-detected", { detail: { open: devtoolsOpen } })
//       );
//     }

//     checking = false;
//   }

//   function start() {
//     if (started) return;
//     started = true;

//     if (!intervalId) {
//       intervalId = setInterval(checkDevtools, 2000);
//     }
//     window.addEventListener("resize", checkDevtools);
//     window.addEventListener("focus", checkDevtools);

//     // run once immediately if you like
//     checkDevtools();
//   }

//   function stop() {
//     started = false;

//     if (intervalId) {
//       clearInterval(intervalId);
//       intervalId = null;
//     }
//     window.removeEventListener("resize", checkDevtools);
//     window.removeEventListener("focus", checkDevtools);
//   }

//   // Expose API
//   window.DevtoolsSoftDetector = {
//     isOpen: () => devtoolsOpen,
//     start,
//     stop,
//   };

//   // Auto-start by default; you can remove this if you want manual control only
//   //   start();
// })();

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const useDevToolsDetector = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   useEffect(() => {
//     let devtools = { open: false };

//     const interval = setInterval(() => {
//       // Method 1: Detect docked DevTools (any position)
//       const heightDiff = window.outerHeight - window.innerHeight;
//       const widthDiff = window.outerWidth - window.innerWidth;

//       // Thresholds for different positions
//       const bottomThreshold = heightDiff > 160; // DevTools docked bottom
//       const rightThreshold = widthDiff > 160; // DevTools docked right

//       // Method 2: Console detection (works for detached DevTools)
//       const element = new Image();
//       let consoleOpen = false;

//       Object.defineProperty(element, "id", {
//         get: function () {
//           consoleOpen = true;
//         },
//       });

//       // console.dir(element);

//       // Method 3: Performance timing (detects debugger)
//       const start = performance.now();
//       // debugger;
//       const debuggerOpen = performance.now() - start > 100;

//       // Combine all detection methods
//       const isDevToolsOpen = bottomThreshold || rightThreshold || consoleOpen || debuggerOpen;

//       if (isDevToolsOpen !== devtools.open) {
//         devtools.open = isDevToolsOpen;
//         setIsOpen(isDevToolsOpen);
//       }

//       // console.clear();
//     }, 500);

//     return () => clearInterval(interval);
//   }, []);

//   return isOpen;
// };

// const DevToolsDetector = () => {
//   const devToolsOpen = useDevToolsDetector();

//   console.log(devToolsOpen, "devToolsOpen");
//   useEffect(() => {
//     if (devToolsOpen) {
//       // Clear local auth state (example)
//       // localStorage.removeItem("access_token");
//       // sessionStorage.removeItem("access_token");
//       // window.location.href = "/sign-in";
//     }
//     function handler(e) {
//       const detail = e.detail;
//       console.log(detail, "detail");
//       if (!detail?.open) return;

//       // Clear local auth state (example)
//       localStorage.removeItem("access_token");
//       sessionStorage.removeItem("access_token");
//       window.location.href = "/sign-in";
//     }

//     window.addEventListener("devtools-detected", handler);
//     return () => window.removeEventListener("devtools-detected", handler);
//   }, [devToolsOpen]);

//   return null;
// };

// export default DevToolsDetector;
// devtools-detector.js

import appConfig from "../config/appConfig";

(function () {
  let devtoolsOpen = false;
  let lastState = false;
  const threshold = 160; // px – side/top panel minimum width/height

  let checking = false;
  let intervalId = null;
  let started = false;

  function checkBySize() {
    //Check difference between outer and inner dimensions
    const widthDifference = Math.abs(window.outerWidth - window.innerWidth);
    console.log(widthDifference);
    const heightDifference = Math.abs(window.outerHeight - window.innerHeight);

    const widthThreshold = widthDifference > 100;
    const heightThreshold = heightDifference > 200;

    return widthThreshold || heightThreshold;
  }

  function checkByTiming() {
    // "Debugger" time-based trick
    const start = performance.now();
    // ⚠️ In production you may want to comment this out to avoid pauses
    // eslint-disable-next-line no-debugger
    // debugger;
    const end = performance.now();
    return end - start > 100; // ms – tweak as needed
  }

  function checkDevtools() {
    if (!appConfig.isProduction) return;
    if (checking) return;
    checking = true;

    let suspicious = checkBySize();
    console.log(suspicious, "suspicious");

    if (!suspicious) {
      suspicious = checkByTiming();
    }

    devtoolsOpen = suspicious;

    if (devtoolsOpen !== lastState) {
      lastState = devtoolsOpen;
      window.dispatchEvent(
        new CustomEvent("devtools-detected", { detail: { open: devtoolsOpen } })
      );
    }

    checking = false;
  }

  function start() {
    if (started) return;
    started = true;

    if (!intervalId) {
      intervalId = setInterval(checkDevtools, 2000);
    }
    window.addEventListener("resize", checkDevtools);
    window.addEventListener("focus", checkDevtools);

    // run once immediately if you like
    checkDevtools();
  }

  function stop() {
    started = false;

    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    window.removeEventListener("resize", checkDevtools);
    window.removeEventListener("focus", checkDevtools);
  }

  // Expose API
  window.DevtoolsSoftDetector = {
    isOpen: () => devtoolsOpen,
    start,
    stop,
  };

  // Auto-start by default; you can remove this if you want manual control only
  //   start();
})();
